import { GetAllUsersInDto } from '../../../types/user.dto'

export const GET_ALL_USERS_STATICS = 'GET_ALL_USERS_STATICS'
export const GET_ALL_USERS_STATICS_SUCCESS = 'GET_ALL_USERS_STATICS_SUCCESS'
export const GET_ALL_USERS_STATICS_ERROR = 'GET_ALL_USERS_STATICS_ERROR'
export const RESET_GET_ALL_USERS_STATICS = 'RESET_GET_ALL_USERS_STATICS'

export interface GetAllUsersStatics {
  type: typeof GET_ALL_USERS_STATICS
  payload: null
}

export interface GetAllUsersStaticsSuccess {
  type: typeof GET_ALL_USERS_STATICS_SUCCESS
  payload: GetAllUsersInDto
}

export interface GetAllUsersStaticsError {
  type: typeof GET_ALL_USERS_STATICS_ERROR
  payload: string | boolean
}

export interface ResetGetAllUsersStatics {
  type: typeof RESET_GET_ALL_USERS_STATICS
  payload: null
}

export interface State {
  data: GetAllUsersInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllUsersStatics
  | GetAllUsersStaticsSuccess
  | GetAllUsersStaticsError
  | ResetGetAllUsersStatics
